import { defineStore } from 'pinia'

export default defineStore('order', {
  state: () => ({
    orderId: '',
    paymentStatus: '',
    paymentMessage: '',
  }),
})